import { render, staticRenderFns } from "./DetailSPRPage.vue?vue&type=template&id=e8a4d64e&scoped=true&"
import script from "./DetailSPRPage.vue?vue&type=script&lang=js&"
export * from "./DetailSPRPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailSPRPage.vue?vue&type=style&index=0&id=e8a4d64e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a4d64e",
  null
  
)

export default component.exports